import Api from "../api";
import { Contract } from "@/services/contracts/types";

export async function getContracts(): Promise<Array<Contract >> {
    return new Promise((resolve, reject) => {
        Api.get("/contract").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getContract(id: string): Promise<Contract> {
    return new Promise((resolve, reject) => {
        Api.get(`/contract/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createContract(contract: Contract): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/contract", contract).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function updateContract(contract: Contract): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/contract", contract).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function deleteContract(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/contract/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
